import React from 'react';
import ReactPagination from 'react-js-pagination';

const Pagination = ({
	totalCount,
	currentPage,
	pageSize,
	onChange,
	hideFirstLastPages,
}) => {
	return (
		<>
			<ReactPagination
				activePage={currentPage}
				itemsCountPerPage={pageSize}
				totalItemsCount={totalCount}
				prevPageText={'‹'}
				nextPageText={'›'}
				onChange={onChange}
				hideFirstLastPages={hideFirstLastPages}
				itemClassFirst={'first'}
				itemClassLast={'last'}
				itemClassPrev={'prev'}
				itemClassNext={'next'}
				activeClass={'on'}
				activeLinkClass={''}
			/>
		</>
	);
};

export default Pagination;
